import { openDialog } from '../base/dialog/actions';
import DesktopPicker from './components/DesktopPicker';
/**
 * Signals to open a dialog with the DesktopPicker component.
 *
 * @param {Object} options - Desktop sharing settings.
 * @param {Function} onSourceChoose - The callback to invoke when
 * a DesktopCapturerSource has been chosen.
 * @returns {Object}
 */
export function showDesktopPicker(options = {}, onSourceChoose) {
    const { desktopSharingSources } = options;
    return openDialog('DesktopPicker', DesktopPicker, {
        desktopSharingSources,
        onSourceChoose
    });
}
